module.exports = __webpack_public_path__ + "img/energieagentur.ec9c0e02.svg";